import React from 'react';
import ClinicAppointmentIcon from '../../images/new-home-card-images/ClinicAppointment.svg';
import HospitalizationIcon from '../../images/new-home-card-images/Hospitalization.svg';
import HraIcon from '../../images/new-home-card-images/Hra.svg';
import LabTestsIcon from '../../images/new-home-card-images/LabTests.svg';
import MedicineDeliveryIcon from '../../images/new-home-card-images/MedicineDelivery.svg';
import OnlineConsultationsIcon from '../../images/new-home-card-images/OnlineConsultations.svg';
import ReimbursementIcon from '../../images/new-home-card-images/Reimbursement.svg';
import EnrollmentIcon from '../../images/new-home-card-images/EnrollmentIcon.svg';
import CubesIcon from '../../images/new-home-card-images/Cubes.svg';
import vaccineIcon from '../../images/vaccination/Icon_syringe.svg';
import CashlessDental from '../../images/new-home-card-images/cashless-dental.svg';
import HospitalNetworkIcon from '../../images/new-home-card-images/HospitalNetwork.svg';
import styled from 'styled-components';
import GooglePlay from '../../images/download-app/play-store.svg';
import ApplePlay from '../../images/download-app/app-store.svg';
import { useSelector } from 'react-redux';
const OuterContainer1 = styled.div`
  width: 440px
  display: flex;

  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  background: #fff;
  display: flex;
  justify-content: center;
  @media (max-width: 440px) {
    width: 100vw;
  }
`;

const OuterContainer = styled.div`
  position: relative;
  width: calc(100% - 15px);
  background: radial-gradient(
    122.85% 53.75% at 50% 50%,
    #ffffff 0%,
    #f0edfa 100%
  );
  border: 1px solid #dcdae6;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  flex-direction: column;
  z-index: 10;
  cursor: pointer;
  width: 90%;
  min-width: 157px;
`;

const Title = styled.p`
  font-size: 14px;

  font-weight: 600;
  line-height: 16.8px;
`;

const Offer = styled.div`
  background: #1eb865;
  color: #ffffff;
  border-radius: 0px 0px 12px 12px;
  padding: 1px 8px 1px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  position: absolute;
  top: 0px;
  display: flex;
`;
const BodyContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
`;
const SubHeadings = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  margin-left: 30px;
  margin-top: 4px;
  margin-bottom: 20px;
`;
const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  background: #ffffff;
  padding: 16px 30px 16px 30px;
  border-radius: 16px;
  margin-bottom: 8px;
`;
const HeaderContainer = styled.div`
  align-self: stretch;

  width: 440px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 15px 34px;
  border-bottom: 1px solid #f0f3f6;
  @media (max-width: 440px) {
    width: 100vw;
  }
`;

const HeaderLogo = styled.img`
  height: 1.875rem;
`;

const getImageFromIconType = (key) => {
  switch (key) {
    case 'offline-consults':
      return ClinicAppointmentIcon;
    case 'hospitalisation':
      return HospitalizationIcon;
    case 'hra-card':
      return HraIcon;
    case 'diagnostics':
      return LabTestsIcon;
    case 'pharmacy':
      return MedicineDeliveryIcon;
    case 'online-consults':
      return OnlineConsultationsIcon;
    case 'reimbursement':
      return ReimbursementIcon;
    case 'enrollment':
      return EnrollmentIcon;
    case 'cashless-vaccination':
      return vaccineIcon;
    case 'cashless-dental':
      return CashlessDental;
    case 'web':
      return HospitalNetworkIcon;
    default:
      return null;
  }
};

function NewHomeActionCard({ iconType, title, offer, onTap }) {
  return (
    <OuterContainer onClick={onTap} id={'new-action-cards'}>
      <div className="flex flex-col items-center">
        <img
          src={getImageFromIconType(iconType)}
          width={'60px'}
          height={'60px'}
        />
        <Title className="text-center mt-8px">{title}</Title>
      </div>

      <img
        src={CubesIcon}
        className="absolute"
        style={{ bottom: 0, right: 0, zIndex: '0' }}
      />
    </OuterContainer>
  );
}
const renderConsoleCards = (card) => {
  switch (card.cardType) {
    case 'hospitalisation':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Hospitalisation'}
            offer={card.offer}
          />
        </div>
      );
    case 'reimbursement':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Reimbursements'}
            offer={card.offer}
          />
        </div>
      );
    case 'online-consults':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Online Consultations'}
            offer={card.offer}
          />
        </div>
      );
    case 'offline-consults':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Clinic Appointment'}
            offer={card.offer}
          />
        </div>
      );
    case 'pharmacy':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Medicine Delivery'}
            offer={card.offer}
          />
        </div>
      );
    case 'diagnostics':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Lab Tests'}
            offer={card.offer}
          />
        </div>
      );
    case 'hra-card':
      return (
        <>
          <div className="flex justify-center items-center">
            <NewHomeActionCard
              iconType={card.cardType}
              title={'Health Risk Assessment'}
              offer={card.offer}
            />
          </div>
        </>
      );
    case 'cashless-vaccination':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={card.label}
            offer={card.offer}
          />
        </div>
      );
    case 'html':
      return (
        <>
          {card.icon === 'enrollment' &&
            Boolean(card?.cardDirective?.action?.redirectTo) && (
              <div className="flex justify-center items-center">
                <NewHomeActionCard
                  iconType={card.icon}
                  title={card.label}
                  offer={card.offer}
                />
              </div>
            )}
        </>
      );
    case 'web':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Hospital Network'}
            offer={card.offer}
          />
        </div>
      );
    case 'cashless-dental':
      return (
        <div className="flex justify-center items-center">
          <NewHomeActionCard
            iconType={card.cardType}
            title={'Cashless Dental'}
            offer={card.offer}
          />
        </div>
      );
  }
};
const UserBenefits = () => {
  const sponsorLogo =
    'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-2914.png';
  const consoleCards = [
    {
      cardType: 'online-consults',
    },
    {
      cardType: 'pharmacy',
    },
    {
      cardType: 'diagnostics',
    },
  ];
  return (
    <OuterContainer1>
      <HeaderContainer>
        <div>
          <HeaderLogo src={sponsorLogo} alt="Logo" />
        </div>
        <div></div>
      </HeaderContainer>
      <BodyContainer>
        <div
          className="flex flex-col"
          style={{
            paddingBottom: '30px',
            borderBottom: '8px solid #EDEDF0',
            paddingTop: '16px',
          }}
        >
          <SubHeadings>Services</SubHeadings>
          <div className="gridContainer">
            {consoleCards.map(renderConsoleCards)}
          </div>
        </div>
        <ItemContainer className="mt-15">
          <div className="flex flex-col w-full pb-6 pr-3">
            <div className="mb-5">
              <h1 className="text-icon font-bold text-title-m my-1">
                Visit App works best on your mobile
              </h1>
              <h3 className="text-icon font-bold text-title-s my-1">
                Download app to explore all benefits
              </h3>
            </div>
            <div className="flex justify-between mt-6">
              <div className="flex gap-2 align-items-center justify-between">
                <a href="https://vsyt.me/o/d">
                  <img
                    src={GooglePlay}
                    style={{
                      width: '145px',
                      height: '53px',
                    }}
                  />
                </a>
                <a href="https://vsyt.me/o/d">
                  <img
                    src={ApplePlay}
                    style={{
                      width: '145px',
                      height: '53px',
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
        </ItemContainer>
      </BodyContainer>
    </OuterContainer1>
  );
};

export default UserBenefits;
